import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Features} from './features';
import {Roles} from './roles';
import {ConditionalFunctions} from './conditional-functions';
import {ApiService} from '../api/api.service';
import {Role} from '../../classes/role.class';
import {LocalStorage} from '../../utils/storage';
import {Feature} from '../../classes/feature.class';

@Injectable({
    providedIn: 'root'
})
export class AuthorisationService {

    constructor(public apiService: ApiService) {
    }

    public static hasRole(roleKey: Roles, params?: any) {
        const user = LocalStorage.user;
        return !!user?.roles?.find(role =>
            role.key === roleKey &&
            (!role.conditional_function ||
                ConditionalFunctions[role.conditional_function](user, role, params))
        );
    }

    public static hasAnyRole(roleKeys: Roles[]) {
        return !!roleKeys.find(roleKey => {
            return this.hasRole(roleKey);
        });
    }

    public static hasFeature(featureKey: Features, obj?: object) {
        const user = LocalStorage.user;
        return !!user?.roles?.find(role => {
            return this.hasRole(role.key, obj) && role.role_features.find(rf =>
                rf.feature.key === featureKey
                && (!rf.user_field || (obj && obj[rf.user_field] === user.id))
            );
        });
    }

    public static hasAnyFeature(featureKeys: Features[], obj?: object) {
        return !!featureKeys.find(featureKey => {
            return this.hasFeature(featureKey, obj);
        });
    }

    public getRoles(): Observable<Role[]> {
        return this.apiService.getCall$<Role[]>('auth/roles').pipe(map(r => r.data));
    }

    public getFeatures(): Observable<Feature[]> {
        return this.apiService.getCall$<Feature[]>('auth/features').pipe(map(r => r.data));
    }

    public addFeatureToRole(feature_id, role_id, user_field?: string) {
        return this.apiService.postCall$('auth/addFeatureToRole', {
            role_id,
            feature_id,
            user_field
        });
    }

    public removeFeatureFromRole(feature_id, role_id) {
        return this.apiService.postCall$('auth/removeFeatureFromRole', {
            role_id,
            feature_id
        });
    }
}
